import { render, staticRenderFns } from "./newCloudPhone.vue?vue&type=template&id=1fdacb74&scoped=true"
import script from "./newCloudPhone.vue?vue&type=script&lang=js"
export * from "./newCloudPhone.vue?vue&type=script&lang=js"
import style0 from "./newCloudPhone.vue?vue&type=style&index=0&id=1fdacb74&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fdacb74",
  null
  
)

export default component.exports